module.exports = __webpack_public_path__ + "img/xirepair-logo.acd5cc93.jpg";